import NewReportRunModal from 'components/CleanRooms/CurrentQuestions/NewReportRunModal/NewReportRunModal';


export default NewReportRunModal;
